import { useMediaQuery } from "@mui/system";
import { Grid, Box, Chip, LinearProgress, Typography } from "@mui/material";
import { FunctionField, Labeled, useRecordContext } from "react-admin";
import { settings } from "app";
import { StudyDurationUnitChoices } from "utils/choices";
import { SectionTitle } from "features/SectionTitle";

const DurationProgressSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();
  if (!record) return null;

  const {
    requiredDurationInDays = 0,
    usedDurationInDays = 0,
    effectiveDurationCapInDays = 0,
    fullyCoversStudyDuration,
  } = record;

  const percent = requiredDurationInDays > 0 ? Math.min((usedDurationInDays / requiredDurationInDays) * 100, 100) : 0;
  const overCap = usedDurationInDays > effectiveDurationCapInDays;
  const durationUnitLabel = StudyDurationUnitChoices.find(c => c.id === record.studyDurationUnit)?.name ?? "";

  return (
    <>
      <SectionTitle
        title="Покритие на обучението"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Продължителност по програма">
            <FunctionField
              render={rec => (
                <Typography>
                  {rec?.studyDuration} {durationUnitLabel}
                </Typography>
              )}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Необходими дни">
            <FunctionField render={rec => <Typography>{rec?.requiredDurationInDays} дни</Typography>} />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Максимален лимит (с доп. обучения)">
            <FunctionField render={rec => <Typography>{rec?.effectiveDurationCapInDays} дни</Typography>} />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          display="flex"
          alignItems="center"
        >
          <Chip
            label={fullyCoversStudyDuration ? "Покрива обучението" : "Не покрива обучението"}
            color={fullyCoversStudyDuration ? "success" : "warning"}
            size="medium"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box sx={{ flexGrow: 1 }}>
              <LinearProgress
                variant="determinate"
                value={percent}
                color={overCap ? "error" : fullyCoversStudyDuration ? "success" : "primary"}
                sx={{ height: 10, borderRadius: 5 }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{ whiteSpace: "nowrap" }}
            >
              {usedDurationInDays} / {requiredDurationInDays} дни (макс. {effectiveDurationCapInDays})
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default DurationProgressSection;
